import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

const activeAddWrapperStyles = css`
  background-color: ${COLORS.surface};
  border-style: solid;
  border-color: ${COLORS.border};

  path {
    fill: ${COLORS.secondarySemiDark};
  }
`

export const ReferenceImagesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ReferenceImagesOuterContainer = styled.div`
  position: relative;
  width: 108px;
  height: 108px;
  flex-shrink: 0;

  .loading-spinner {
    position: absolute;
  }
`

export const LoadingSpinnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  background-color: ${COLORS.fillSubtle};
`

export const AddImageIconWrapper = styled.div<{
  $isToggled?: boolean
}>`
  width: 100%;
  height: 100%;

  border-radius: 8px;
  border: 1px dashed ${COLORS.secondarySemiLight};
  background-color: ${COLORS.fillSubtle};

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease-in-out;
  cursor: pointer;

  path {
    fill: ${COLORS.secondary};
  }
  &:hover {
    ${activeAddWrapperStyles}
  }

  ${({ $isToggled }) =>
    $isToggled &&
    css`
      ${activeAddWrapperStyles}
    `}
`

export const RemoveImageIconWrapper = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    fill: ${COLORS.secondarySemiLight};
  }

  transition: all 0.2s ease-in-out;

  &:hover {
    svg {
      fill: ${COLORS.secondarySemiDark};
    }
  }
`
